import { render, staticRenderFns } from "./RemoveOrganizationModal.vue?vue&type=template&id=00dfbb50&lang=pug"
import script from "./RemoveOrganizationModal.vue?vue&type=script&lang=js"
export * from "./RemoveOrganizationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports